export const screenBudgetQueryKeys = {
  families: ["screen-budget", "families"] as const,
  kids: (familyId: number | null) => ["screen-budget", "kids", familyId] as const,
  adminFamilies: ["screen-budget", "admin", "families"] as const,
  adminParents: (familyId: number | null) => ["screen-budget", "admin", "parents", familyId] as const,
  adminKids: (familyId: number | null) => ["screen-budget", "admin", "kids", familyId] as const,
};
